import { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import NewsletterQueryEn from '../QueriesEn/NewsletterQueryEn';
import NewsletterQueryHi from '../QueriesHi/NewsletterQueryHi';

const NewsletterDataFetcher = ({ setNewsletterData, currentLanguage }) => {
  const newsletterQuery = currentLanguage === 'en' ? NewsletterQueryEn : NewsletterQueryHi;

  const { data: newsletterQueryData} = useQuery(newsletterQuery, {
    fetchPolicy: 'network-only',
    variables: { language: currentLanguage },
  });

  useEffect(() => {
    if (newsletterQueryData) {
      const newsletterData = newsletterQueryData.nodeSimplenewsIssues.nodes;
      setNewsletterData(newsletterData);
      // console.log('Fetched newsletter data:', newsletterData);
    }
  }, [newsletterQueryData, setNewsletterData]);

  return null;
};

export default NewsletterDataFetcher;
